var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.evaluations.length > 0)?_c('WorkCardDiagnostic',{attrs:{"data":_vm.evaluations}}):_c('h4',{staticClass:"mensaje"},[_vm._v("No tienes diagnósticos asociados por ahora.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }